"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.depsDeepEquality = exports.deepEqual = exports.depsShallowEqual = exports.createDependenciesEqualityFn = void 0;
exports.createDependenciesEqualityFn = function (equalityFn) { return function (previous, current) {
    if (previous.length !== current.length)
        return false;
    for (var i = 0; i < previous.length; i++) {
        var prev = previous[i];
        var next = current[i];
        if (prev === next)
            continue;
        if (!equalityFn(prev, next))
            return false;
    }
    return true;
}; };
exports.depsShallowEqual = exports.createDependenciesEqualityFn(function (x, y) { return x === y; });
exports.deepEqual = function (value1, value2, depth) {
    if (depth === void 0) { depth = Infinity; }
    if (value1 === value2)
        return true;
    if (typeof value1 !== typeof value2)
        return false;
    if (typeof value1 !== "object" || typeof value2 !== "object")
        return false;
    if (value1 === null || value2 === null)
        return false;
    var obj1Keys = Object.keys(value1).sort();
    var obj2Keys = Object.keys(value2).sort();
    if (obj1Keys.length !== obj2Keys.length)
        return false;
    for (var i = 0; i < obj1Keys.length; i++) {
        var key1 = obj1Keys[i];
        var key2 = obj2Keys[i];
        if (key1 !== key2)
            return false;
        if (value1[key1] !== value2[key2]) {
            if (depth <= 1)
                return false;
            if (!exports.deepEqual(value1[key1], value2[key2], depth - 1)) {
                return false;
            }
        }
    }
    return true;
};
exports.depsDeepEquality = exports.createDependenciesEqualityFn(exports.deepEqual);
